module.exports = __webpack_public_path__ + "static/media/System_Boundary-wallfinishes.aa058008.png";